module.exports = __webpack_public_path__ + "static/img/active_vip_09.afbfe60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_vip_09.jpg
// module id = 8uMn
// module chunks = 0